"use strict";

var _interopRequireDefault = require("/opt/build/repo/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _BaseInfo = _interopRequireDefault(require("./components/BaseInfo"));

var _WalletInfo = _interopRequireDefault(require("./components/WalletInfo"));

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  name: 'BrandDetail',
  components: {
    BaseInfo: _BaseInfo.default,
    WalletInfo: _WalletInfo.default
  },
  data: function data() {
    return {
      id: '',
      activeName: 'baseInfo'
    };
  }
};
exports.default = _default;